import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getTime/index.js';

var require$$27 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$27 as default };
